import { CommonUtil } from '@utils/common/common';
import { integerFormatter, percentFormatter } from '@utils/common/formatter';

export class KeywordInsightGridOption {
  insightBox(responseData, addDelHandler) {
    const _data = CommonUtil.getArrayByValidate(responseData);
    if (_data.length > 0) {
      let columns = [
        {
          name: 'Keyword',
          selector: (row) => row.keyword,
          sortable: true,
        },
        {
          name: 'Add/Del',
          selector: (row) => row.tracked,
          cell: (row, index, column, id) => (
            <>
              {row.tracked ? (
                <button
                  type="button"
                  className="btn-ico-single delete"
                  title="delete"
                  onClick={() =>
                    addDelHandler({
                      keywordId: row.id,
                      keyword: row.keyword,
                      currentTracked: row.tracked,
                    })
                  }
                >
                  <span className="blind">delete</span>
                </button>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className="ipt-check"
                    id={`checked-table-${row.id}`}
                    checked={false} // 퍼블리싱은 V 처리를 했지만.. 여기선 제외시킨다.
                    onChange={() =>
                      addDelHandler({
                        keywordId: row.id,
                        keyword: row.keyword,
                        currentTracked: row.tracked,
                      })
                    }
                  />
                  <label htmlFor={`checked-table-${row.id}`}>
                    <span className="blind">미선택</span>
                  </label>
                </>
              )}
            </>
          ),
          sortable: true,
        },
        {
          name: 'Search Score',
          selector: (row) => row.searchscore,
          cell: (row) => integerFormatter(row.searchscore),
          sortable: true,
        },
        {
          name: 'Apps',
          selector: (row) => row.apps,
          cell: (row) => integerFormatter(row.apps),
          sortable: true,
        },
        {
          name: 'Chance',
          selector: (row) => row.chance,
          cell: (row) => integerFormatter(row.chance),
          sortable: true,
        },
      ];

      const tempRankArr = _data[0].rank;
      tempRankArr.forEach((rankObj) => {
        let temp = {
          name: (
            <div>
              <div>
                <img src={rankObj.icon} />
              </div>
              <div>{rankObj.title}</div>
            </div>
          ),
          selector: (row) => {
            let appObj = row['rank'].find((item) => item.appId === rankObj.appId && item.type === rankObj.type);
            return appObj.rank;
          },
          cell: (row) => {
            let appObj = row['rank'].find((item) => item.appId === rankObj.appId && item.type === rankObj.type);
            return integerFormatter(appObj?.rank);
          },
          sortable: true,
        };
        //@ts-ignore
        columns.push(temp);
      });

      return {
        data: _data,
        columns,
      };
    } else {
      return {
        data: [],
        columns: [
          {
            name: 'Keyword',
          },
          {
            name: 'Add/Del',
          },
          {
            name: 'Search Score',
          },
          {
            name: 'Apps',
          },
          {
            name: 'Chance',
          },
        ],
      };
    }
  }
}
